import React from "react";

const Files = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M8.4 10.321v-4.74c0-.42.169-.822.469-1.118A1.61 1.61 0 0 1 10 4h10.262l3.2 3.16H32.4c.424 0 .831.167 1.131.463.3.297.469.699.469 1.118v15.802c0 .42-.169.821-.469 1.118a1.61 1.61 0 0 1-1.131.462h-4.8v4.741c0 .42-.169.821-.469 1.118a1.61 1.61 0 0 1-1.131.462H3.6a1.61 1.61 0 0 1-1.131-.462A1.57 1.57 0 0 1 2 30.864V11.901c0-.419.169-.82.469-1.117A1.61 1.61 0 0 1 3.6 10.32h4.8Zm0 3.16H5.2v15.803h19.2v-3.16h-16V13.482Z"
            fill={fill}
        />
    </svg>
);

export default Files;
